module.exports = __webpack_public_path__ + "static/wt-scrollable-a46ef54627ecdcb08219d14a6ee0f6c6.png";